/* eslint-disable  import/no-cycle, func-names */

import Vuex from "vuex";
import Vue from "vue";
import test from "./modules/test";
import main from "./modules/main";
import admin from "./modules/admin";
import catalogs from "./modules/catalogs";
import diagrams from "./modules/diagrams";
import documentEditor from "./modules/documentEditor";
import version from "./modules/version";
import apis from "./modules/apis";
import apps from "./modules/apps";
import tasks from "./modules/tasks";
import userProfile from "./modules/userProfile";
import components from "./modules/components";
import reports from "./modules/reports";
import smartContractDesigner from "./modules/smartContractDesigner";
import dashboard from "./modules/dashboard";
import rules from "./modules/rules";
import GDM from "./modules/GDM";
import dataStore from "./modules/dataStore";
import users from "./modules/users";
import perspectiveBuilder from "./modules/perspectiveBuilder";
import aWallet from "./modules/aWallet";

Vue.use(Vuex);

export default function () {
    return new Vuex.Store({
        modules: {
            main,
            test,
            admin,
            diagrams,
            documentEditor,
            catalogs,
            version,
            apis,
            apps,
            tasks,
            userProfile,
            smartContractDesigner,
            components,
            reports,
            dashboard,
            rules,
            GDM,
            dataStore,
            perspectiveBuilder,
            aWallet,
            users
        }
    });
}
